import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { UploadedFile } from 'app/models/entities/uploaded-file';
import { LegfiFilesizePipe } from '../../../../../pipes/format/legfi-filesize.pipe';

/** A record's uploaded files as kit file rows: size, email tag, view, download and delete. */
@Component({
    selector: 'app-attachment-list',
    templateUrl: './attachment-list.component.html',
    standalone: true,
    imports: [NgIf, NgForOf],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentListComponent
{
    @Input() files: UploadedFile[] = [];
    @Input() deletable = true;
    @Input() deletingId: number | null = null;
    @Output() delete = new EventEmitter<UploadedFile>();

    private readonly _fileSize = new LegfiFilesizePipe();

    meta(file: UploadedFile): string | null {
        return file.fileSize ? this._fileSize.transform(file.fileSize) : null;
    }

    open(url: string): void {
        window.open(url, '_blank', 'noopener');
    }

    trackById(_: number, file: UploadedFile): number {
        return file.id;
    }
}
